<style lang="less" scoped>
  .iframe {
    border: 0;
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
  }
</style>

<template>
  <page-container
    :title="$t('使用手册')" cover>
      <iframe class="iframe" :src="url"></iframe>
  </page-container>
</template>

<script>
import PageContainer from '../../components/PageContainer'

export default {
  name: 'manual',
  components: { PageContainer },
  data () {
    return {
      viewer: '/pdf.js/web/viewer.html',
      pdf: '/pdf/SI_APP_MANUAL.pdf'
    }
  },
  computed: {
    url () {
      return `${this.viewer}?file=${encodeURIComponent(this.pdf)}`
    }
  }
}
</script>
